<script lang="ts">
  import { useWallet } from '@do/svelte-web3-manager';

  import { getPrice } from '@shared/utils/blockchain';

  const wallet = useWallet();
</script>

<article class="text-default-900 mt-5 rounded-lg bg-yellow-100 p-3 dark:bg-yellow-200">
  <p class="mb-1 text-sm font-medium">
    Your Wallet Balance: {getPrice($wallet?.balance.usdc)} USDC / {getPrice($wallet?.balance.eth)} ETH
  </p>

  <p class="text-default-800 text-xs">
    Insufficient funds. Please top up your crypto wallet balance to proceed with this transaction.
    <slot />
  </p>
</article>
